module.exports = __webpack_public_path__ + "img/max-ulichney-explorers.806873b.jpg";